import { loadPolyfillIfNeeded } from "@lit-labs/virtualizer/polyfillLoaders/ResizeObserver.js";

async function load() {
  await loadPolyfillIfNeeded();
  await import("@lit-labs/virtualizer");
}

load()
